"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InvisibleClimate() {
  const [scrollY, setScrollY] = useState(0);
  const [scrollIndicatorVisible, setScrollIndicatorVisible] = useState(true);
  const {
    ref: textRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrollY(y);
      if (y > 50) setScrollIndicatorVisible(false);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="754" id="die-unsichtbare-revolution" className="dark bg-background text-foreground relative w-full min-h-screen overflow-hidden">
      {}
      <div className="hidden lg:grid grid-cols-12 min-h-screen">
        {}
        <div className="col-span-7 relative overflow-hidden">
          <div className="absolute inset-0 will-change-transform" style={{
          transform: `translateY(${scrollY * 0.3}px)`
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png-wvc-sizes" alt="Komfortables Schlafzimmer mit unsichtbarer Ducted AC Klimaanlage" className="w-full h-[115%] object-cover" loading="eager" decoding="async" />
          </div>
          {}
          <div className="absolute inset-0 pointer-events-none opacity-[0.04] mix-blend-overlay" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
        }} />
        </div>

        {}
        <div className="col-span-5 relative flex flex-col justify-between">
          {}
          <div className="flex justify-end pt-12 pr-12">
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground" style={{
            letterSpacing: "0.2em"
          }}>
              KLIMATISIERUNG FÜR PRIVATHAUSHALTE
            </span>
          </div>

          {}
          <div ref={textRef} className="pl-12 pr-12 pb-16 max-w-xl" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 900ms ease-out, transform 900ms ease-out"
        }}>
            {}
            <div className="mb-8">
              <span className="font-mono text-xs uppercase" style={{
              letterSpacing: "0.22em",
              color: "var(--chart-2)"
            }}>
                01 / PERFEKTES RAUMKLIMA
              </span>
            </div>

            {}
            <h1 className="font-default font-light text-foreground leading-[1.02]" style={{
            fontSize: "clamp(4.5rem, 6.5vw, 7rem)",
            letterSpacing: "-0.03em"
          }}>
              Die unsichtbare Klimaanlage
              <span className="block italic font-light text-foreground/85">
                Perfektes Klima ohne sichtbare Geräte
              </span>
            </h1>

            {}
            <div className="mt-10 mb-8 h-px w-16 bg-foreground/40" />

            {}
            <p className="font-default text-base leading-relaxed text-muted-foreground max-w-md">
              Kühlen, hocheffizient heizen und die gesetzlichen Vorgaben (EWärmeG BW) clever erfüllen – komplett im Dachboden versteckt. Erleben Sie flüsterleise, zugfreie Luft in Ihrem Zuhause.
            </p>

            {}
            <div className="mt-10 flex items-center gap-8">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-7 h-12 font-default text-sm tracking-wide">
                <Link to="/SolutionPage">
                  Die Lösung entdecken
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Link to="/ContactPage" className="font-default text-sm text-foreground border-b border-foreground/40 hover:border-foreground pb-1 transition-colors">
                Jetzt Beratung anfragen
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="lg:hidden flex flex-col min-h-screen">
        {}
        <div className="relative h-[70vh] w-full overflow-hidden">
          <div className="absolute inset-0 will-change-transform" style={{
          transform: `translateY(${scrollY * 0.2}px)`
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/Luftventil klein.png-wvc-sizes" alt="Komfortables Schlafzimmer mit unsichtbarer Ducted AC Klimaanlage" className="w-full h-[115%] object-cover" loading="eager" decoding="async" />
          </div>
          <div className="absolute inset-0 pointer-events-none opacity-[0.04] mix-blend-overlay" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
        }} />
          {}
          <div className="absolute top-6 right-6">
            <span className="font-mono text-[10px] uppercase text-foreground/90" style={{
            letterSpacing: "0.2em"
          }}>
              KLIMATISIERUNG FÜR PRIVATHAUSHALTE
            </span>
          </div>
        </div>

        {}
        <div className="flex-1 px-6 sm:px-10 pt-10 pb-16">
          <div className="mb-6">
            <span className="font-mono text-[11px] uppercase" style={{
            letterSpacing: "0.22em",
            color: "var(--chart-2)"
          }}>
              01 / PERFEKTES RAUMKLIMA
            </span>
          </div>

          <h1 className="font-default font-light text-foreground leading-[1.04]" style={{
          fontSize: "clamp(2.75rem, 9vw, 3.75rem)",
          letterSpacing: "-0.03em"
        }}>
            Die unsichtbare Klimaanlage
            <span className="block italic font-light text-foreground/85">
              Perfektes Klima ohne sichtbare Geräte
            </span>
          </h1>

          <div className="mt-7 mb-6 h-px w-12 bg-foreground/40" />

          <p className="font-default text-[15px] leading-relaxed text-muted-foreground max-w-md">
            Kühlen, hocheffizient heizen und die gesetzlichen Vorgaben (EWärmeG BW) clever erfüllen – komplett im Dachboden versteckt. Erleben Sie flüsterleise, zugfreie Luft in Ihrem Zuhause.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 h-12 font-default text-sm tracking-wide w-full sm:w-auto">
              <Link to="/SolutionPage">
                Die Lösung entdecken
                <ArrowRight className="size-4" />
              </Link>
            </Button>

            <Link to="/ContactPage" className="font-default text-sm text-foreground border-b border-foreground/40 hover:border-foreground pb-1 transition-colors self-start sm:self-auto">
              Jetzt Beratung anfragen
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="hidden lg:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-3 pointer-events-none" style={{
      opacity: scrollIndicatorVisible ? 1 : 0,
      transition: "opacity 500ms ease-out"
    }}>
        <span className="font-mono text-[10px] uppercase text-muted-foreground" style={{
        letterSpacing: "0.3em"
      }}>
          Scroll
        </span>
        <div className="relative h-12 w-px bg-foreground/20 overflow-hidden">
          <div className="absolute top-0 left-0 w-px h-6 bg-foreground/70" style={{
          animation: "scrollLine 1.8s ease-in-out infinite"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}